import React, { useEffect, useState } from 'react';
import styles from '../../styles/header/header.module.css';
import { NavLink } from 'react-router-dom';
import jwt_decode from "jwt-decode";
function Header() {
    const [r, setR] = useState(false);
    const [username, setUsername] = useState("");
    let isTokenAvailable = sessionStorage.getItem("token");
    useEffect(() => {
        if (isTokenAvailable) {
            const decoded = jwt_decode(isTokenAvailable);
            const r = decoded.userInfo['r'];
            if (r === 1) {
                setR(true);
            }
            setUsername(decoded.userInfo['username'])
        }
    }, [])
    return (
        <>
            <div className="d-flex flex-row position-relative justify-content-start z9 m-header" onContextMenu={(e) => e.preventDefault()}>
                <div className={`${styles.borderBottom} ${styles.ml} ${styles.colorWhite}`}>
                    <a href="#" className={styles.logoText}>{username}</a>
                </div>
                <div className={`${styles.ml} ${styles.colorWhite} ${styles.ulWrapper} d-flex flex-row position-relative justify-content-end`}>
                    <ul className={styles.ulWrapperUl}>
                        <li className={styles.ulWrapperUlLi}>
                            <NavLink to='/home' className={styles.navLinkli}>
                                Home
                            </NavLink></li>
                        {(r &&
                            <li className={styles.ulWrapperUlLi}>
                                <NavLink to='/manage' className={styles.navLinkli}>
                                    Manage
                                </NavLink></li>
                        )}
                        <li className={styles.ulWrapperUlLi}>
                            <NavLink to='/logout' className={styles.navLinkli}>
                                Logout
                            </NavLink></li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default React.memo(Header);